import { Component, OnInit } from '@angular/core';
import { Router, ActivationEnd } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { UserService } from '../../services/services.index';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styles: []
})
export class BreadcrumbsComponent implements OnInit {

  titulo: string;

  constructor(private _router: Router, public _userService: UserService) {
    this.getRouter().subscribe(data => {
      this.titulo = data.titulo;
    });
  }

  ngOnInit() {
  }

  getRouter() {
    return this._router.events.pipe(
      filter((evento) => {
        return evento instanceof ActivationEnd;
      }),
      filter((evento: ActivationEnd) => {
        return (evento.snapshot.firstChild === null);
      }),
      map((evento: ActivationEnd) => {
        return evento.snapshot.data;
      })
    );
  }

  goHome() {
    if (this._userService.user.role === 'ADMIN_ROLE') {
      this._router.navigate(['/escritorio-admin']);
    } else {
      this._router.navigate(['/dashboard']);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/breadcrumbs/breadcrumbs.component.ts